import templateUrl from './userTimeoffTableComponent.html';

class UserTimeoffTableCtrl {
  constructor(Authentication, ShiftUtils, LeaveService, Utils, extendLeaveModel, sdk) {
    'ngInject';

    Object.assign(this, { Authentication, ShiftUtils, LeaveService, Utils, extendLeaveModel, sdk });
  }

  $onInit() {
    this.ShiftUtils.loadAsync();
  }

  $onChanges() {
    if (!this.data?.summary || !('caps' in this.data)) {
      return;
    }

    if (this.Authentication.user?.orgSettings.useGlobalLeaveCap) {
      const [cap, remaining] = this._calculateCapAndRemaining();
      if (cap) {
        this.summary = {
          remainingGlobal: remaining,
        };
      }
      this._setSummarySchemaForGlobalCap();
      return;
    }

    this.summary = this.LeaveService.availableTimeOffTypes
      .filter((t) => t.paid)
      .reduce((agg, leaveType) => {
        const [cap, remaining] = this._calculateCapAndRemaining(leaveType);
        if (cap) {
          agg[`remaining_${leaveType.id}`] = remaining;
        }
        return agg;
      }, {});
    this._setSummarySchemaForCapPerType(this.summary);
  }

  get rows() {
    return this.data?.leaves;
  }

  get showLeaveType() {
    return (
      this.Authentication.isOrgFeatureEnabled('leaveTypes') &&
      this.Authentication.user.orgSettings.leaveTypesEnabled
    );
  }

  statusClassMap = {
    cancelled: 'color-brand-danger',
    published: 'color-brand-success',
    pending_admin: 'color-brand-warning',
  };

  editLeave(leave) {
    this.ShiftUtils.viewTimeOff(
      this.extendLeaveModel({
        type: this.sdk('constants').LEAVE_TYPE,
        user: { id: this.user.id },
        ...leave,
      })
    );
  }

  _setSummarySchemaForGlobalCap() {
    if (this.summarySchema?.globalCap) {
      return this.summarySchema;
    }

    this.summarySchema = {
      globalCap: true,
      items: [
        {
          label: 'REMAINING',
          property: 'remainingGlobal',
          formula: 'data.remainingGlobal',
          unit: 'none',
        },
      ],
    };
  }

  _setSummarySchemaForCapPerType(summary) {
    if (this.summarySchema?.capPerType) {
      return this.summarySchema;
    }

    this.summarySchema = {
      capPerType: true,
      items: this.LeaveService.availableTimeOffTypes
        .filter((t) => t.paid)
        .filter((t) => summary[`remaining_${t.id}`])
        .map((leaveType) => ({
          label: `REMAINING ${leaveType.name}`,
          property: `remaining_${leaveType.id}`,
          formula: `data.remaining_${leaveType.id}`,
          unit: 'none',
        })),
    };
  }

  _calculateCapAndRemaining(timeOffType) {
    const usedMinutes = this.LeaveService.getLeaveUsed(timeOffType, this.data.summary);
    const cap = this.LeaveService.getCapForTypeInMinutes(timeOffType, this.data.caps);

    if (!cap) {
      return [null, null];
    }

    if (this.LeaveService.units === 'DAYS') {
      return [cap, this.LeaveService.getDurationTime(cap - usedMinutes, false)];
    }

    return [
      cap,
      this.Utils.getDisplayDuration(
        cap - usedMinutes,
        this.Authentication.user.settings.usTimeFormat,
        false, // short
        false // disallowNegative
      ),
    ];
  }
}

export default {
  bindings: {
    data: '<',
    user: '<',
  },
  controllerAs: 'ctrl',
  controller: UserTimeoffTableCtrl,
  templateUrl,
};
